module.exports = __webpack_public_path__ + "static/media/Lampent_gaussian2.0b225626.png";